module.exports = __webpack_public_path__ + "img/logo_innobuilder.b010f0b9.png";